import type { LegalDocumentVersions } from "@/api/errors";
import { PRIVACY_VERSION } from "@/content/privacy.meta";
import { TERMS_VERSION } from "@/content/terms.meta";
import apiClient from "./client";

export const DISPLAYED_LEGAL_DOCUMENT_VERSIONS: LegalDocumentVersions = {
  terms: TERMS_VERSION,
  privacy: PRIVACY_VERSION,
};

interface LegalDocumentVersionsResponse {
  versions: LegalDocumentVersions;
}

export interface LegalAcceptanceResponse extends LegalDocumentVersionsResponse {
  acceptances: Array<{
    document: keyof LegalDocumentVersions;
    version: string;
    accepted_at: string;
    client: "web" | "mobile";
    ip_hash: string;
  }>;
}

export async function getLegalDocumentVersions(): Promise<LegalDocumentVersions> {
  const { data } = await apiClient.get<LegalDocumentVersionsResponse>("/accounts/legal-documents/");
  return data.versions;
}

export async function acceptLegalDocuments(
  client: "web" | "mobile",
  token?: string,
): Promise<LegalAcceptanceResponse> {
  const { data } = await apiClient.post<LegalAcceptanceResponse>(
    "/accounts/legal-acceptance/",
    { client, versions: DISPLAYED_LEGAL_DOCUMENT_VERSIONS },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );
  return data;
}
